module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The B Word")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01#frontmatter01"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02#frontmatter02"
    }
  }, [_vm._v("PROLOGUE   "), _c('em', [_vm._v("Chasing Amy")]), _vm._v(" and Bisexual (In)visibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter03#frontmatter03"
    }
  }, [_vm._v("INTRODUCTION   Binary Trouble and Compulsory Monosexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1   Unthinking Monosexuality: Bisexual"), _c('br'), _vm._v("Representability in Art Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Power Play/s: Bisexuality as Privilege and Pathology in Sexploitation Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   Of Cowboys and Cocksmen: Bisexuality and the Contemporary Hollywood Bromance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   Bisexuality on the Boob Tube")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION   Queer/ing Bisexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter04#backmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0